import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Organicé toda la temporada en una tarde. Tengo cada sesión pensada para todos mis grupos. Nunca más el domingo de pánico sin saber qué trabajar el lunes.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
    role: 'Entrenadora de Fútbol Femenino en Club Barrial'
  }, {
    quote: 'Las sesiones con progresión real por nivel cambiaron todo. Mis jugadoras mejoraron más en 2 meses que en toda la temporada anterior. Y dejaron de abandonar.',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'DT de Fútbol Femenino Juvenil'
  }, {
    quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas planificar qué hacer con un grupo heterogéneo de jugadoras.',
    name: 'Valentina F.',
    location: 'Córdoba',
    role: 'Entrenadora de Fútbol Femenino Grupal e Individual'
  }];
  return <section className="py-10 md:py-20 px-4 bg-gray-50" data-id="element-317">
      <div className="max-w-6xl mx-auto" data-id="element-318">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-319">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-5 md:p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-320">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-321">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-yellow-400 text-yellow-400" data-id="element-322" />)}
              </div>
              <p className="text-gray-700 italic mb-4 md:mb-6 flex-grow text-base md:text-lg" data-id="element-323">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto" data-id="element-324">
                <p className="font-bold text-navy text-base md:text-lg" data-id="element-325">
                  {testimonial.name}
                </p>
                <p className="text-brandGreen font-semibold text-sm mb-1" data-id="element-326">
                  {testimonial.location}
                </p>
                <p className="text-gray-500 text-sm" data-id="element-327">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}